import { render } from "./app-apikeys-card.vue?vue&type=template&id=f8b3e7d2&scoped=true"
import script from "./app-apikeys-card.vue?vue&type=script&lang=js"
export * from "./app-apikeys-card.vue?vue&type=script&lang=js"

import "./app-apikeys-card.vue?vue&type=style&index=0&id=f8b3e7d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b3e7d2"]])

export default __exports__